import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	projects: {
		id: 'command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.projects.projects',
		defaultMessage: 'Projects',
		description: 'Section title for projects',
	},
});
